import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { Nullable } from '@/shared/types/app.types'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { textTemplatesConfigurationServices } from '@/modules/configurationModule/detail/templates/text-templates/services/text-templates.services'
import { store } from '@/store/store'
import { ConfigurationTextTemplateResponse } from '@/modules/configurationModule/detail/templates/text-templates/services/text-templates.dto'

export const columnsDefTextTemplatesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.textTemplate'),
            field: 'title',
            minWidth: 400,
            flex: 2,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.editable'),
            field: 'textEditionAllowed',
            flex: 1,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 1,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface TextTemplateGridState extends CrudModelPaginatorLaboratory<ConfigurationTextTemplateResponse>{
    labId: number
    broadcastChannel: Nullable<BroadcastChannel>
}
export const initialTextTemplatesGridState =
    (): TextTemplateGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.templates.textTemplates',
        columnsDef: columnsDefTextTemplatesGrid(),
        datasource: new PaginatorLaboratoryDatasource(textTemplatesConfigurationServices, store.getters.labId),
        labId: store.getters.labId,
        broadcastChannel: null
    })
